import { jsx as s, jsxs as g } from "react/jsx-runtime";
import * as f from "react";
import { c as P, P as p } from "../index-RcgQH_g_.js";
var c = "Progress", d = 100, [W, j] = P(c), [z, N] = W(c), y = f.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: x,
      value: i = null,
      max: o,
      getValueLabel: H = I,
      ...S
    } = e;
    (o || o === 0) && !u(o) && console.error(B(`${o}`, "Progress"));
    const r = u(o) ? o : d;
    i !== null && !m(i, r) && console.error(R(`${i}`, "Progress"));
    const n = m(i, r) ? i : null, _ = l(n) ? H(n, r) : void 0;
    return /* @__PURE__ */ s(z, { scope: x, value: n, max: r, children: /* @__PURE__ */ s(
      p.div,
      {
        "aria-valuemax": r,
        "aria-valuemin": 0,
        "aria-valuenow": l(n) ? n : void 0,
        "aria-valuetext": _,
        role: "progressbar",
        "data-state": b(n, r),
        "data-value": n ?? void 0,
        "data-max": r,
        ...S,
        ref: t
      }
    ) });
  }
);
y.displayName = c;
var h = "ProgressIndicator", v = f.forwardRef(
  (e, t) => {
    const { __scopeProgress: x, ...i } = e, o = N(h, x);
    return /* @__PURE__ */ s(
      p.div,
      {
        "data-state": b(o.value, o.max),
        "data-value": o.value ?? void 0,
        "data-max": o.max,
        ...i,
        ref: t
      }
    );
  }
);
v.displayName = h;
function I(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function b(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function l(e) {
  return typeof e == "number";
}
function u(e) {
  return l(e) && !isNaN(e) && e > 0;
}
function m(e, t) {
  return l(e) && !isNaN(e) && e <= t && e >= 0;
}
function B(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${d}\`.`;
}
function R(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${d} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var $ = y, V = v;
const w = "320px", E = "600px", M = "1025px", A = "_isVisuallyHidden_1ueot_51", k = "_value_1ueot_63", C = "_progressWrapper_1ueot_76", D = "_progressRoot_1ueot_80", L = "_progressIndicator_1ueot_98", a = {
  mobile: w,
  "mobile-wide": "480px",
  tablet: E,
  "tablet-wide": "800px",
  desktop: M,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  isVisuallyHidden: A,
  value: k,
  progressWrapper: C,
  progressRoot: D,
  progressIndicator: L
}, G = ({ ...e }) => {
  e["aria-label"] || console.warn(
    "Progress component must provide and `aria-label`, `aria-labelledby` or `title` attribute "
  );
  const { value: t } = e;
  return typeof t != "number" ? null : /* @__PURE__ */ g("div", { className: a.progressWrapper, children: [
    /* @__PURE__ */ g("p", { className: a.value, children: [
      t,
      "%"
    ] }),
    /* @__PURE__ */ s($, { className: a.progressRoot, ...e, children: /* @__PURE__ */ s(
      V,
      {
        className: a.progressIndicator,
        style: { transform: `translateX(-${100 - t}%)` }
      }
    ) })
  ] });
};
export {
  G as Progress
};
